export default class Usuario {
	matricula: string;
	nome: string;
	isTecnicoExterno: boolean;
	isValidate: boolean;
	email?: string;
	origemInternet?: boolean;
}